import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Box, Tooltip } from "@mui/material";
import type { Address } from "@types_def/models/address.types";

function formatAddress(address?: Partial<Address> | null): string {
  if (!address) {
    return "-";
  }

  const parts = [
    address.address ?? "",
    address.city ?? "",
    address.postalCode ?? "",
    address.country ?? "",
  ];
  const filtered = parts.filter(
    (part): part is string => typeof part === "string" && part.trim().length > 0
  );
  return filtered.join(" - ") || "-";
}

export function RouteTrajectory({
  from,
  to,
}: {
  from?: Partial<Address> | null;
  to?: Partial<Address> | null;
}) {
  const fromLabel = from?.city ?? "-";
  const toLabel = to?.city ?? "-";
  const chipStyle = {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    px: 0.75,
    py: 0.25,
    borderRadius: 1,
    bgcolor: "grey.100",
    fontSize: "0.8125rem",
    fontWeight: 500,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Tooltip title={fromLabel !== "-" ? `Départ: ${formatAddress(from)}` : ""}>
        <Box sx={chipStyle}>
          <LocationOnIcon sx={{ fontSize: 14, color: "success.main", flexShrink: 0 }} />
          <Box component="span" sx={{ overflow: "hidden", textOverflow: "ellipsis" }}>
            {fromLabel}
          </Box>
        </Box>
      </Tooltip>
      <ArrowForwardIcon sx={{ fontSize: 14, color: "text.secondary", flexShrink: 0 }} />
      <Tooltip title={toLabel !== "-" ? `Arrivée: ${formatAddress(to)}` : ""}>
        <Box sx={chipStyle}>
          <LocationOnIcon sx={{ fontSize: 14, color: "error.main", flexShrink: 0 }} />
          <Box component="span" sx={{ overflow: "hidden", textOverflow: "ellipsis" }}>
            {toLabel}
          </Box>
        </Box>
      </Tooltip>
    </Box>
  );
}
